import React from 'react';
import { FormattedMessage } from 'react-intl';

// TODO: used for sync reduxValidator by key, need to learn/check how to use errors for translation and from the backend
const HelperTextError = ({ meta, isError }) => {
  const { error } = meta;
  return isError ? <FormattedMessage id={`message.${error.split(' ').join('_')}`} defaultMessage={error} /> : null;
};

export default HelperTextError;
